import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-portfolio-schweppes',
  templateUrl: './portfolio-schweppes.component.html',
  styleUrls: ['./portfolio-schweppes.component.sass']
})
export class PortfolioSchweppesComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.getParamValues();
  }

  getParamValues() {
    this.route.queryParams.subscribe(params => {  // this.id =     
       if (params['lang']) {
          this.translate.use(params['lang']);
       }
    });
  }

  scroll(id) {
  	const bodyRect = document.body.getBoundingClientRect()
  	const elemRect = document.getElementById(id).getBoundingClientRect()
  	const positionTop:number = elemRect.top - bodyRect.top

  	window.scroll({
  		top: positionTop > 0 ? positionTop : 0,
    	behavior: 'smooth',
  	})
  }

}



// WEBPACK FOOTER //
// ./src/app/portfolio-schweppes/portfolio-schweppes.component.ts